export default {
	appName: "Speed",
	version: "5.8.0",
	SocketIOUrl: "https://speedeast.jimmyinteractive.com",
	GameServers: [
		"https://speedeast.jimmyinteractive.com",
	],
	FullVersion: false,
	ShowErrors: false,
	DebugMode: false,
	FacebookAdId: 158327870889130,
	hideAppLinks: true,
	hideMoreGames: false,
	hideReportBug: false,
	hideAboutGame: false,
	ShowIAPPage: true,
	hideRateGame: false,
	hideSuggestions: false,
	hideLogin: false,
	TestMode: false,
	maxPingAllowed: 500,
	autoTestMode: false,
	RemoveAds: false,
	GAProperty: "UA-43146845-1",
	ios: '914247866',
	android: 'com.jimmyinteractive.speed',
	windows: '9ntj99b0pblj',
	email: 'speed@jdsoftwarellc.com',
	amazon: 'B00Z2ZUAYO',
	webRateURL: 'https://cardsjd.com',
	emailSubject: 'Speed Feedback',
	shareUrl: 'https://cardsjd.com/speed/',
	shareTitle: 'Speed the Card Game',
	shareText: "I'm addicted to Speed the Card Game",
	shareImage: './Icons/Icon_512x512.png',
	storageName: 'speed.userdata',
	accountJDUrl: 'https://account.jdsoftwarellc.com/',
	gamesUrl: 'https://cardsjd.com/config/moregames.json',
	discordClientId: '1220609923747024906',
	overrides: {
		facebook: {
			autoLogin: true,
			hideSuggestions: true,
			hideReportBug: true,
			hideAboutGame: true,
			hideRateGame: true,
			hideLogin: true,
		},
		facebook_ios: {
			hideMoreGames: true,
		},
		steam: {
			autoLogin: true,
			hideMoreGames: false,
			hideReportBug: false,
			hideAboutGame: false,
		}
	}
}


